const PRODUCTION_HOSTNAMES = new Set(["reelitpro.com", "www.reelitpro.com"]);
const NON_PRODUCTION_HOSTNAMES = new Set([
  "localhost",
  "127.0.0.1",
  "::1",
  "staging.reelitpro.com",
]);
const NON_PRODUCTION_ENVS = new Set(["development", "dev", "local", "staging", "test"]);

function normalizeValue(value) {
  return String(value || "").trim().toLowerCase();
}

export function getRuntimeHostname() {
  if (typeof window === "undefined" || !window.location) {
    return "";
  }
  return normalizeValue(window.location.hostname);
}

export function getDeployEnv() {
  return normalizeValue(process.env.REACT_APP_DEPLOY_ENV);
}

export function isProductionVisibilityEnvironment({
  deployEnv = getDeployEnv(),
  hostname = getRuntimeHostname(),
} = {}) {
  const normalizedDeployEnv = normalizeValue(deployEnv);
  const normalizedHostname = normalizeValue(hostname);

  if (normalizedDeployEnv === "production" || normalizedDeployEnv === "prod") {
    return true;
  }

  if (PRODUCTION_HOSTNAMES.has(normalizedHostname)) {
    return true;
  }

  if (NON_PRODUCTION_ENVS.has(normalizedDeployEnv)) {
    return false;
  }

  if (NON_PRODUCTION_HOSTNAMES.has(normalizedHostname)) {
    return false;
  }

  return false;
}

export function getFeatureVisibility(options = {}) {
  const isProduction = isProductionVisibilityEnvironment(options);
  const showProductionWip = !isProduction;
  // TODO: Re-enable Local Fishing Regulations in production when the regulations feature/content is completed.
  const enableLocalFishingRegulations = !isProduction;

  return {
    isProduction,
    showMyStats: showProductionWip,
    showMarket: showProductionWip,
    showGearDeals: showProductionWip,
    showComingSoonSidebar: showProductionWip,
    showRecipePostTab: showProductionWip,
    showExploreTrips: showProductionWip,
    allowGearDealsRoute: showProductionWip,
    allowMarketTab: showProductionWip,
    allowComingSoonRoutes: showProductionWip,
    showRegulationsNav: enableLocalFishingRegulations,
    allowRegulationsRoute: enableLocalFishingRegulations,
  };
}

const runtimeFeatureVisibility = getFeatureVisibility();

export const isProductionFeatureVisibility =
  runtimeFeatureVisibility.isProduction;
export const showMyStats = runtimeFeatureVisibility.showMyStats;
export const showMarket = runtimeFeatureVisibility.showMarket;
export const showGearDeals = runtimeFeatureVisibility.showGearDeals;
export const showComingSoonSidebar =
  runtimeFeatureVisibility.showComingSoonSidebar;
export const showRecipePostTab = runtimeFeatureVisibility.showRecipePostTab;
export const showExploreTrips = runtimeFeatureVisibility.showExploreTrips;
export const allowGearDealsRoute = runtimeFeatureVisibility.allowGearDealsRoute;
export const allowMarketTab = runtimeFeatureVisibility.allowMarketTab;
export const allowComingSoonRoutes =
  runtimeFeatureVisibility.allowComingSoonRoutes;
export const showRegulationsNav = runtimeFeatureVisibility.showRegulationsNav;
export const allowRegulationsRoute =
  runtimeFeatureVisibility.allowRegulationsRoute;

export default runtimeFeatureVisibility;
